export default {
  accountsLoading: false,
  accounts: [],
  transitionMode: null,
  transitionAccount: null
}
